module.exports = __webpack_public_path__ + "static/screen-web-win-laptop-1112f41b0982bac81c3bab1b7c927edb.png";